import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { formatDateForDisplay } from '../../../../helpers/date-time';

import ButtonIcon from '../../../../component-library/button-icon';

const Ticket = ({
	ticket,
}) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<>
			<tr className={isOpen ? 'border-bottom-none' : ''}>
				<td className={isOpen ? 'border-bottom-none' : ''}>{ticket.number.display_value}</td>
				<td className={isOpen ? 'border-bottom-none' : ''}>{ticket.short_description.display_value}</td>
				<td className={isOpen ? 'border-bottom-none' : ''}>{ticket.priority.display_value}</td>
				<td className={isOpen ? 'border-bottom-none' : ''}>{ticket.type.display_value}</td>
				<td className={isOpen ? 'border-bottom-none' : ''}>{ticket.state.display_value}</td>
				<td className={`text-right ${isOpen ? 'border-bottom-none' : ''}`}>
					<ButtonIcon
						icon={isOpen ? 'chevron-up' : 'chevron-down'}
						onClick={() => setIsOpen(!isOpen)}
					/>
				</td>
			</tr>
			{isOpen && (
				<tr>
					<td colSpan={6}>
						<div className="flex-row margin-bottom-16">
							<div className="margin-right-32">
								<strong>Risk: </strong>
								{ticket.risk.display_value}
							</div>
							<div className="margin-right-32">
								<strong>Urgency: </strong>
								{ticket.urgency.display_value}
							</div>
							<div className="margin-right-32">
								<strong>Impact: </strong>
								{ticket.impact.display_value}
							</div>
						</div>
						<strong>Description:</strong>
						<p className="margin-bottom-16">{ticket.description.display_value}</p>
						<div className="flex-row">
							<div className="margin-right-32">
								<strong>Opened At: </strong>
								{formatDateForDisplay(ticket.opened_at.display_value)}
							</div>
							<div className="margin-right-32">
								<strong>Closed At: </strong>
								{ticket.closed_at.display_value?.length > 0 ? formatDateForDisplay(ticket.closed_at.display_value) : '-'}
							</div>
						</div>
					</td>
				</tr>
			)}
		</>
	);
};

export default Ticket;

Ticket.propTypes = {
	ticket: PropTypes.shape({
		number: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
		short_description: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
		description: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
		priority: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
		state: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
		type: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
		risk: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
		urgency: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
		impact: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
		opened_at: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
		closed_at: PropTypes.shape({
			display_value: PropTypes.string.isRequired,
		}).isRequired,
	}).isRequired,
};
